import React from 'react';

import { Stack } from '@lyearn/ui';

const EmptyStateStackItem = () => {
  return (
    <Stack
      alignItems="stretch"
      className="w-full h-full rounded-16 border border-dashed border-border p-8 -mt-2"
      direction="row"
      gapX={12}></Stack>
  );
};

export default EmptyStateStackItem;
